import type { AxiosResponse } from "axios";

import config from "@/common/config";

import ApiService from "./api.service";
import type { ApiResponse, FeatureFlags } from "./types";

interface FeatureFlagsResponse {
  featureFlags: FeatureFlags;
}

export default {
  VERSION: config.api.versions.v2,

  featureFlags(): Promise<AxiosResponse<ApiResponse<FeatureFlagsResponse>>> {
    return ApiService.get("/user/feature-flags", this.VERSION);
  }
};
